// extracted by mini-css-extract-plugin
export var background = "type-page-module--background--592a0";
export var chapo = "type-page-module--chapo--1d971";
export var header = "type-page-module--header--96261";
export var headerImg = "type-page-module--headerImg--75310";
export var internalMeshWrapper = "type-page-module--internalMeshWrapper--52e5f";
export var metaData = "type-page-module--metaData--cf78e";
export var title = "type-page-module--title--4a56b";